export default {
    endDate: {
        invalidDate: 'date.range.picker.error.end.date.invalid.date',
        invalidDateRange: 'date.range.picker.error.invalid.date.range',
        maxDate: 'date.range.picker.error.out.of.range',
        minDate: 'date.range.picker.error.out.of.range',
        noDate: 'date.range.picker.error.invalid.date.range',
    },
    startDate: {
        invalidDate: 'date.range.picker.error.start.date.invalid.date',
        invalidDateRange: 'date.range.picker.error.invalid.date.range',
        maxDate: 'date.range.picker.error.out.of.range',
        minDate: 'date.range.picker.error.out.of.range',
        noDate: 'date.range.picker.error.invalid.date.range',
    },
};
